let timeRegex = new RegExp(/^(2[0-3]|[01][0-9]):[0-5][0-9]$/);

export function isValidTime(timeString, allowNull = false) {
    if (allowNull && !timeString) return true;
    else return timeRegex.test(timeString);
}
